<template>
  <div>
    <HeaderBanner :banner-height.sync="bannerHeight" />
    <FixedHeader
      :show-mobile-header.sync="showMobileHeader"
      :window-top="windowTop"
      :add-class-fixed="addClassFixed"
      :tree-categories.sync="treeCategories"
      :fixed-height.sync="fixedHeight"
    />
    <transition name="slide-fade" mode="out-in">
      <MobileHeader
        v-if="showMobileHeader"
        :show-mobile-header.sync="showMobileHeader"
        :tree-categories.sync="treeCategories"
      />
    </transition>
    <!--    <div class="dep_bg"></div>-->
  </div>
</template>

<script>
import HeaderBanner from './HeaderBanner'
import FixedHeader from './FixedHeader'
import MobileHeader from './MobileHeader'
import { fetchTreeList } from '@/api/productCate'

export default {
  name: 'HeaderIndex',
  components: {
    HeaderBanner,
    FixedHeader,
    MobileHeader
  },
  data() {
    return {
      showMobileHeader: false,
      bannerHeight: 0,
      fixedHeight: 0,
      windowTop: 0,
      addClassFixed: false,
      treeCategories: [
        {
          id: null,
          name: '',
          menuIcon: '',
          icon_on: '',
          children: [
            {
              id: null,
              name: ''
            }
          ]
        }
      ]
    }
  },
  methods: {
    onScroll(e) {
      this.windowTop =
        window.top.scrollY /* or: e.target.documentElement.scrollTop */
      if (this.bannerHeight > 0) {
        if (this.windowTop > this.bannerHeight) {
          this.addClassFixed = true
          this.$store.dispatch('setPaddingTop', this.fixedHeight - 100)
        } else {
          this.addClassFixed = false
          this.$store.dispatch('setPaddingTop', 0)
        }
      } else if (this.windowTop > 0) {
        this.addClassFixed = true
        this.$store.dispatch('setPaddingTop', this.fixedHeight - 100)
      } else {
        this.addClassFixed = false
        this.$store.dispatch('setPaddingTop', 0)
      }
    },
    getTreeCategoryList() {
      fetchTreeList().then(response => {
        this.treeCategories = response.data
        this.treeCategories.map(category => {
          category.menuIcon = require(`@/assets/images/${category.menuIcon}`)
          category.onIcon = require(`@/assets/images/${category.icon.replace(
            '.png',
            '_on.png'
          )}`)
          return category
        })
      })
    }
  },
  created() {
    this.getTreeCategoryList()
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll)
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.onScroll)
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/layout/components/Header/index.vue